import { SystemStyleObject } from '@enechain/ecloud-designsystem'

export function getStickyStyle({
  leftPosition,
  backgroundColor,
}: {
  leftPosition: string
  backgroundColor: string
}): SystemStyleObject {
  return {
    position: 'sticky',
    zIndex: 1,
    left: leftPosition,
    backgroundColor,
  }
}

export function getWordBreakStyle(): SystemStyleObject {
  return {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  }
}

export function getOverflowEllipsis(): SystemStyleObject {
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
}

export function getTextAlignLightTableStyle(): {
  headerStyle: SystemStyleObject
  cellStyle: SystemStyleObject
} {
  return {
    headerStyle: {
      textAlign: 'right',
    },
    cellStyle: {
      textAlign: 'right',
    },
  }
}
